import { NumericFormat as NumberFormat } from 'react-number-format';

export const PercentFormatDisplay = ({ value }: { value: string | number }) => {
  return <NumberFormat value={value} displayType={'text'} thousandSeparator={true} suffix=' %' />;
};
